import { Col, Row } from "@amzn/stencil-react-components/layout";
import { Text } from "@amzn/stencil-react-components/text";
import React, { FC } from "react";

export const NoMessagesView: FC = () => (
  <Col gridGap="S400" width="100%" data-testid="no-messages-view">
    <Row>
      <Text fontWeight="bold">No messages yet</Text>
    </Row>
    <Row>
      <Text>
        You don&apos;t have any messages for this order. Use the &quot;Get order support&quot; option to start a
        conversation with the Procurement team.
      </Text>
    </Row>
  </Col>
);
